<script>
  /* Executable code section of the program */
  //Components importation
  import UploadFiles from "../UploadFiles.svelte";
  //Tool importation
  import { alertMessagge, excelAttendeeData, isAlertOn, isConfirmModalOn, isUploadFilesModalOn,confirmResponse,isReloadNecessary,updateDataExcel } from "../../apis/storage";
  import { postMultipleDocuments,updateMultipleFieldsForMultipleDocs } from "../../apis/APIS";
  import ConfirmModal from "./ConfirmModal.svelte";

  //Function to undisplay modal
  const undisplayModal = () => {
    $isUploadFilesModalOn = false;
    $excelAttendeeData = []

  };

  //Function to displa alert
  const displayAlert = () =>{
    $isAlertOn = true
  }
  //Function to display confirm modal
  const displayConfirmModal = () =>{
    $isConfirmModalOn = true
    $alertMessagge = "Are you sure you want to add each of the following data?"
  }
  
  //Function to create profiles
  const createProfiles = () => {
    if ($confirmResponse) {      
      postMultipleDocuments("users", $excelAttendeeData).then(()=>{
        updateMultipleFieldsForMultipleDocs("users",$updateDataExcel)
        $alertMessagge = "All documents have been added successfully."
        $isReloadNecessary = true
        displayAlert()
      })
      $isUploadFilesModalOn = false;
    }
  };
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="sectionContainer">
  <div class="UploadFileContainer">
    <div class="headerContainer">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-circle icon"
        viewBox="0 0 16 16"
        on:keypress={() => undisplayModal()}
        on:click={() => undisplayModal()}
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
        />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
    <div class="bodyContainer">
      <UploadFiles />
    </div>
    <div class="footerContainer">
      <button class="actionBtn" on:click={() => undisplayModal()}>Close</button>
      <button class="actionBtn addEventBtn" on:click={displayConfirmModal}
        >Create Profiles</button
      >
    </div>
  </div>
</section>
{#if $isConfirmModalOn}
  <ConfirmModal callbackFunction = {createProfiles}/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .sectionContainer {
    position: absolute;
    top: 0;
    z-index: 888;
    width: 100%;
    height: auto;
    min-height: 160vh;
    background-color: rgba(0, 0, 0, 0.432);
    padding: 30px;
    display: flex;
    justify-content: center;
  }
  .UploadFileContainer {
    background-color: white;
    width: 80%;
    height: auto;
    max-height: 90dvh;
    overflow: auto;
    padding: 50px;
  }
  .headerContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 15px;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  .bodyContainer{
    height: auto;
    max-height: 60dvh;
    overflow: auto;
  }
  .footerContainer {
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid gray;
  }
  .actionBtn {
    width: 150px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .UploadFileContainer {
    background-color: white;
    width: 90%;
    height: 50%;
    padding: 50px;
  }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .UploadFileContainer {
    background-color: white;
    width: 100%;
    height: 50%;
    padding: 20px;
  }
  .actionBtn {
    width: 200px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
  }
  }

  /* End of the section */
</style>
